import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, LinkedinIcon, TwitterIcon, GlobeIcon, SendIcon, ArrowUpRightIcon } from 'lucide-react';
export const Footer = () => {
  return <footer id="contact" className="bg-black text-white py-16" data-id="element-117">
      <div className="container mx-auto px-6" data-id="element-118">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-119">
          <div data-id="element-120">
            <div className="mb-6" data-id="element-121">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hkWGY44RQgzNCHJG7k4dv9/Logo_Icon.png" alt="Sales Source Logo" className="h-12" data-id="element-122" />
            </div>
            <p className="text-white/80 mb-8 leading-relaxed" data-id="element-123">
              Unlock maximum sponsorship revenue with data-driven, outsourced
              sales that deliver predictable results.
            </p>
            <div className="flex space-x-4" data-id="element-124">
              <a href="https://www.linkedin.com/company/sales-source/" className="text-white/60 hover:text-[#FF7A39] transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-125">
                <LinkedinIcon size={22} data-id="element-126" />
              </a>
            </div>
          </div>
          <div data-id="element-127">
            <h3 className="text-xl font-bold mb-6" data-id="element-128">Contact Us</h3>
            <div className="space-y-5" data-id="element-129">
              <div className="flex items-start gap-4" data-id="element-130">
                <PhoneIcon size={20} className="text-[#FF7A39] mt-1 flex-shrink-0" data-id="element-131" />
                <p className="text-white/80" data-id="element-132">+31 (0)6 22906971</p>
              </div>
              <div className="flex items-start gap-4" data-id="element-133">
                <MailIcon size={20} className="text-[#FF7A39] mt-1 flex-shrink-0" data-id="element-134" />
                <p className="text-white/80" data-id="element-135">info@salessource.nl</p>
              </div>
              <div className="flex items-start gap-4" data-id="element-136">
                <GlobeIcon size={20} className="text-[#FF7A39] mt-1 flex-shrink-0" data-id="element-137" />
                <p className="text-white/80" data-id="element-138">www.salessource.nl</p>
              </div>
              <div className="flex items-start gap-4" data-id="element-139">
                <MapPinIcon size={20} className="text-[#FF7A39] mt-1 flex-shrink-0" data-id="element-140" />
                <p className="text-white/80" data-id="element-141">Amsterdam, NL</p>
              </div>
            </div>
          </div>
          <div data-id="element-142">
            <h3 className="text-xl font-bold mb-6" data-id="element-143">Quick Links</h3>
            <ul className="space-y-4" data-id="element-144">
              <li data-id="element-145">
                <a href="#services" className="text-white/80 hover:text-[#FF7A39] transition-colors flex items-center gap-2 group" data-id="element-146">
                  <span data-id="element-147">Services</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-148" />
                </a>
              </li>
              <li data-id="element-149">
                <a href="#process" className="text-white/80 hover:text-[#FF7A39] transition-colors flex items-center gap-2 group" data-id="element-150">
                  <span data-id="element-151">How It Works</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-152" />
                </a>
              </li>
              <li data-id="element-153">
                <a href="#results" className="text-white/80 hover:text-[#FF7A39] transition-colors flex items-center gap-2 group" data-id="element-154">
                  <span data-id="element-155">Success Stories</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-156" />
                </a>
              </li>
              <li data-id="element-157">
                <a href="#resources" className="text-white/80 hover:text-[#FF7A39] transition-colors flex items-center gap-2 group" data-id="element-158">
                  <span data-id="element-159">Resources</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-160" />
                </a>
              </li>
              <li data-id="element-161">
                <a href="#about" className="text-white/80 hover:text-[#FF7A39] transition-colors flex items-center gap-2 group" data-id="element-162">
                  <span data-id="element-163">About</span>
                  <ArrowUpRightIcon size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-164" />
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 mt-8 border-t border-white/20 text-center text-white/40" data-id="element-165">
          <p data-id="element-166">
            &copy; {new Date().getFullYear()} Sales Source. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};